import { ItemStatus, Item } from "data/entities/entities";

//import { StatusType, Item } from "../../../data/entities/entities";
import { EntityController } from "pages/entity/entity-controller";
import { autoinject} from 'aurelia-dependency-injection';
import { EventAggregator } from 'aurelia-event-aggregator';
import { IKanbanColumn } from 'core/IKanbanColumn';
import { AppEvents } from 'core/app-events';
import { EntityStatuses } from 'core/enums';
import { DialogService } from 'aurelia-dialog';
import { EditKanbanDialog } from 'pages/entity/components/edit-kanban-dialog';
import { bindable } from "aurelia-framework";
import { AddTaskDialog } from 'pages/entity/components/add-task-dialog';
import { ItemDataService } from "data/service/item-data-service";

@autoinject()
export class KanbanView {

    @bindable
    selectedEntityStatusTypeId: number = EntityStatuses.Active;

   	showAddKanbanItemDialog(item) {
		var newItem = this.itemDataService.getNew();
		this.dialogService.open({ viewModel: AddTaskDialog, model: newItem }).whenClosed(response => {
			if (!response.wasCancelled) {
				//Add to Kanban
				this.entityController.addNewTask(response.output);
				
			}
		});
	}

    showEditKanbanDialog(item) {

        this.dialogService.open({ viewModel: EditKanbanDialog, model: item }).whenClosed(response => {
            if (!response.wasCancelled) {

            }
        });
    }

    onIconDragEnter(event) {
        event.target.classList.add('grow-on-drag');
    }

    onIconDragLeave(event) {
        event.target.classList.remove('grow-on-drag');
    }

    removeDropborder(currentElement) {
        currentElement.classList.remove('drag-drop-border');
    }

    addDropborder(currentElement) {
        currentElement.classList.add('drag-drop-border');
    }

    addNoEventClass(element: HTMLElement) {
        element.classList.add('no-event');
    }

    removeNoEventClass(element: HTMLElement)
    {
        element.classList.remove('no-event');
    }

    onColumnDragEnter(event) {
        this.addNoEventClass(event.target);
        this.addDropborder(event.target);
    }

    onColumnDragLeave(event) {
        this.removeNoEventClass(event.target);
        this.removeDropborder(event.target);
    }
    
    onArchiveDrop(event) {
        event.target.classList.remove('grow-on-drag');
        let item = this.getDraggedItem(event.dataTransfer.getData("text/plain"));
        if (item) {
            this.processIconDrop(item, EntityStatuses.Archived);
        }
    }

    onTrashDrop(event) {
        event.target.classList.remove('grow-on-drag');
        let item = this.getDraggedItem(event.dataTransfer.getData("text/plain"));
        if (item) {
            this.processIconDrop(item, EntityStatuses.Trashed);
        }
    }

    processIconDrop(item: Item, entityStatus:EntityStatuses) {
		this.removeFromCurrentColumn(item);
		item.entityStatusId = entityStatus;
		this.entityController.saveItem(item);
    }

    

    children: Array<Item>;

    kanbanColumns: Array<IKanbanColumn> = [];

    constructor(
        private entityController: EntityController,
        private eventAggregator: EventAggregator,
		private dialogService: DialogService,
		private itemDataService: ItemDataService
    ) {
        this.eventAggregator.subscribe(AppEvents.CHILDREN_CHANGED, (data) => this.childrenChanged(data));
        this.eventAggregator.subscribe(AppEvents.NEW_ITEM_ADDED, (item) => this.itemAdded(item));
    }

    itemAdded(item: Item) {
        this.children._add(item);
        this.addToColumn(item);
    }
    
    processKanbanDrop(item: Item, column: IKanbanColumn) {
        this.removeFromCurrentColumn(item);
        item.itemStatusId = column.itemStatus.id;
        column.items._add(item);
        this.entityController.addRelatedItems(item);
        item.save();
    }

    addToColumn(item: Item) {
        let currentColumn = this.kanbanColumns.find((a) => a.itemStatus.id === item.itemStatusId);
        if (currentColumn) {
            currentColumn.items._add(item);
        }
        else {
            throw new Error("kanban_view.addToColumn: Column not found");
        }
    }

    removeFromCurrentColumn(item: Item) {
        let currentColumn = this.kanbanColumns.find((a) => a.itemStatus.id === item.itemStatusId);
        if (currentColumn)
        {
            currentColumn.items._remove(item);
        }
        else {
            throw new Error("kanban_view.removeFromCurrentColumn: Current Column not found");
        }
    }

    childrenChanged(data)
    {
        if (data)
        {
            this.children = data;
            this.filterItemsByStatus();
            
        }
    }

	filterItemsByStatus() {
		this.kanbanColumns = [];
		//Note this is a hack to sort the types so the kanban board flows correctly.
		//Need to have all Status Types customizable so user can choose how to sort column.
		const sortedItemStatuses = this.entityController.metadataService.itemStatuses;

		for (let itemStatus of sortedItemStatuses) {
			if (itemStatus.showAsColumn) {
				let column = { itemStatus: itemStatus, items: [] };
				for (let item of this.children) {
					if (item.itemStatusId === itemStatus.id) {
						column.items._add(item);
					}
				}
				this.kanbanColumns._add(column);
			}
		}
	}


  //  filterItemsByStatus_Old()
  //  {
		//this.kanbanColumns = [];
		////Note this is a hack to sort the types so the kanban board flows correctly.
		////Need to have all Status Types customizable so user can choose how to sort column.
		//const sortedStatusTypes = this.entityController.metadataService.itemStatuses;
		
  //      for (let statusType of sortedStatusTypes) {
  //          if (statusType.showAsColumn) {
  //              let column = { statusType: statusType, items: [] };
  //              for (let item of this.children) {
  //                  if (item.itemStatusId === statusType.id) {
  //                      column.items._add(item);
  //                  }
  //              }
  //              this.kanbanColumns._add(column);
  //          }
  //      }
  //  }


    dragItem;
        
    dragOverIcon(event) {
        //returning false is the Aurelia way of doing preventDefault();
        //return true to NOT preventDefault();
        return false;
        
    }

    dragOver(event, column:IKanbanColumn) {
        try {
            if (column) {
                
                if (event.target.classList.contains("drop-target"))
                {
                    return false;//preventDefault(); -- Allow Drop
                   
                }
                else
                {
                    return false;//--Don't allow drop;
                }
            }
        } catch (ex) {
            console.log("dragStart Exception was caught:" + ex.message);
        }
        
    }

    dragStart(event, item) {
        try {
            if (item) {
                event.target.style.opacity = '0.4';
                event.dataTransfer.setData("text/plain", item.id);
                return true;
            }
        } catch (ex) {
            console.log("dragStart Exception was caught:" + ex.message);
        }
    }

    dragEnd(event, item) {

        try{
            event.target.style.opacity = '1';
        } catch (ex) {
            console.log("dragStart Exception was caught:" + ex.message);
        }
    }

    getDraggedItem(cId: string) : Item
    {
        let id = parseInt(cId);
        return this.children.find(a => a.id === id);
    }

    resetDragAndDrop(element:HTMLElement)
    {
        element.classList.remove('drag-drop-border');
        element.classList.remove('no-event');
    }

    onColumnDrop(event, column) {
        this.resetDragAndDrop(event.target);
        let item = this.getDraggedItem(event.dataTransfer.getData("text/plain"));
        if (item) {
            this.processKanbanDrop(item, column);
        }
    }
                
    

    


}